<template>
  <section>
    <section class="myclearfix">
      <div
        class="product-spec"
        v-for="(spec, index) in productSpecs"
        :key="spec.title"
        :style="{
          clear:
            index > 0 && productSpecs[index - 1].align === 'right' ? 'both' : ''
        }"
        :class="[
          spec.align == 'right' ? 'spec-right' : '',
          spec.align == 'left' ? 'spec-left' : ''
        ]"
      >
        <slider
          v-if="spec.type === 'slider'"
          :options="spec"
          :active-specs="activeSpecs"
          @setVal="setVal"
        ></slider>
        <option-menu
          v-else-if="spec.type === 'option'"
          :options="spec"
          :active-specs="specs"
          @setVal="setVal"
        ></option-menu>
        <div class="product-spec" v-else-if="spec.type === 'info'">
          <h3>{{ spec.title }}</h3>
          <p v-html="spec.text"></p>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import { useFileListStore } from '@/stores/FileList.store'
import { mapStores } from 'pinia'
import Slider from './product-specs/Slider.vue'
import OptionMenu from './product-specs/OptionMenu.vue'

export default {
  props: ['productSpecs', 'activeSpecs', 'selectedFiles'],
  data() {
    return {
      specs: this.activeSpecs
    }
  },
  components: { Slider, OptionMenu },
  computed: {
    ...mapStores(useFileListStore)
  },
  methods: {
    setVal(type, val) {
      this.fileListStore.updateProductSpec(this.selectedFiles, type, val)

      this.specs[type] = val
    }
  }
}
</script>

<style lang="scss" scoped>
.product-spec {
  margin-bottom: 16px;
}

.spec-right {
  float: right;
  width: 50%;
}

.spec-left {
  float: left;
  width: 50%;
}
</style>
